import { SearchField, SearchInput } from "@/components/ui/search-field";
import { cn } from "@/components/ui/utils";

type TableFilterRowProps = {
  inputProps: React.ComponentProps<typeof SearchField>;
} & React.ComponentProps<"div">;

export function TableFilterRow({
  children,
  inputProps,
  ...props
}: TableFilterRowProps) {
  return (
    <div
      {...props}
      className={cn(
        "flex items-center justify-between gap-2 mb-4",
        props.className,
      )}
    >
      <SearchField
        {...inputProps}
        className={cn("w-full max-w-md", inputProps.className)}
      >
        <SearchInput />
      </SearchField>
      {children}
    </div>
  );
}
